module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/nailCare@2x_0b199d.png";